import Vue from "vue";
import App from "./App.vue";
import { sync } from "vuex-router-sync";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import LogRocket from "logrocket";
import vuetify from "./plugins/vuetify";

sync(store, router);

Vue.config.productionTip = false;

LogRocket.init("myrumg/jtravel");

const FALLBACK_BASE_URL = "https://wercberger-productions.azurewebsites.net/";

const instance = axios.create({
    baseURL: window.location.origin.startsWith("http://localhost")
        ? "https://localhost:44368/"
        : "https://wercbergerproductions-app-164903695581.us-east1.run.app/",
});

function shouldRetryWithFallback(error) {
    const request = error && error.config;

    if (!request || request.__fallbackRetry) {
        return false;
    }

    const requestUrl = request.url || "";
    const isApiRequest = requestUrl.includes("api/");
    const usingFallbackDomain =
        (request.baseURL || "").indexOf(FALLBACK_BASE_URL) === 0;

    return isApiRequest && !usingFallbackDomain;
}

function errorHandler(error) {
    if (error.response && error.response.status == 401) {
        window.location.href = "/login";

        return;
    }

    const text =
        error.response &&
        error.response.data &&
        error.response.data.Message
            ? error.response.data.Message
            : "An error has occurred";

    throw new Error(text);
}

instance.interceptors.request.use(function (config) {
    config.headers.Authorization = store.state.token;

    return config;
});
instance.interceptors.response.use((response) => {
    return response ? response.data : response;
}, async (error) => {
    if (shouldRetryWithFallback(error)) {
        const retryConfig = {
            ...error.config,
            baseURL: FALLBACK_BASE_URL,
            __fallbackRetry: true,
        };

        return instance.request(retryConfig);
    }

    return errorHandler(error);
});

Vue.prototype.$http = instance;

new Vue({
    router,
    vuetify,
    store,
    render: (h) => h(App),
}).$mount("#app");
